var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrevBtnAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.427 11.18a1 1 0 000 1.64l10 7A1 1 0 0020 19V5a1 1 0 00-1.573-.82l-10 7zM18 6.92v10.16L10.744 12 18 6.92z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5a1 1 0 00-2 0v14a1 1 0 102 0V5z",
    fill: "#fff"
  })));
}

export default SvgPrevBtnAudio;